import engFont from '@/assets/stylesheet/engFont.css'
export function setEngStyle(){
   let link = document.createElement("link");
   link.rel = "stylesheet";
   link.href = engFont;
   let head = document.getElementsByTagName("head")[0];
   head.appendChild(link);
}


// WEBPACK FOOTER //
// ./src/utils/addEngStyle.js